import { createAction } from 'redux-act';
import { createAsyncAction } from "./utils";
/**
 * Computes a users financial forecast based on their identity profiles, and returns
 * a set of computed values from this e.g. monthly_income_at_retirement
 * This action *should not* be dispatched on the server
 * */

export var computeFromForecast = createAsyncAction('computeFromForecast', function (options) {
  return {
    makeRequest: function makeRequest(state, opts) {
      return opts.LifelineBrowserSDK.computeFromForecast(options);
    }
  };
});
export var clearCurrentForecast = createAction('clearCurrentForecast', function (options) {
  return options;
});
/**
 * Fetches a set of recommended actions for a given user to improve their retirement.
 * */

export var computeRetirementRecommendations = createAsyncAction('computeRetirementRecommendations', function (options) {
  return {
    makeRequest: function makeRequest(state, opts) {
      return opts.LifelineBrowserSDK.computeRecommendations(options);
    }
  };
});
/**
 * Resets the relevant accounts for a given recommendation
 * */

export var resetReleventRecommendationAccounts = createAction('resetReleventRecommendationAccounts', function (options) {
  return options;
});